import { Controller } from "stimulus"

// Tab-based locale switcher for form fields (e.g. reward title/description,
// FAQ question/answer). Toggles panel visibility and keeps `required` in
// sync with the active panel so hidden inputs don't block submission. On
// submit, if a `required-when-active` field on an inactive tab is empty,
// switch to that tab first so the browser can report the error on a
// visible input.
export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    this.form = this.element.closest("form")
    if (!this.form) return
    this.boundBeforeSubmit = this.beforeSubmit.bind(this)
    this.form.addEventListener("submit", this.boundBeforeSubmit)
  }

  disconnect() {
    if (this.form && this.boundBeforeSubmit) {
      this.form.removeEventListener("submit", this.boundBeforeSubmit)
    }
  }

  selectTab(event) {
    this.applyLocale(event.currentTarget.dataset.locale)
  }

  applyLocale(locale) {
    this.tabTargets.forEach((tab) => {
      const active = tab.dataset.locale === locale
      tab.classList.toggle("btn-primary", active)
      tab.classList.toggle("btn-secondary", !active)
    })

    this.panelTargets.forEach((panel) => {
      const active = panel.dataset.locale === locale
      panel.classList.toggle("hidden", !active)
      panel.querySelectorAll('[data-required-when-active="true"]').forEach((input) => {
        input.required = active
      })
    })
  }

  beforeSubmit(event) {
    const emptyField = Array.from(
      this.element.querySelectorAll('[data-required-when-active="true"]')
    ).find((input) => !input.value.trim())

    if (!emptyField) return

    const panelSelector = `[data-${this.identifier}-target="panel"]`
    const panel = emptyField.closest(panelSelector)
    const activeTab = this.tabTargets.find((tab) => tab.classList.contains("btn-primary"))
    if (!panel || activeTab?.dataset.locale === panel.dataset.locale) return

    event.preventDefault()
    this.applyLocale(panel.dataset.locale)
    this.form.requestSubmit(event.submitter)
  }
}
